import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { onSubscriptionRequired } from "@/api/client";
import { AppProviders } from "@/app/providers";
import { router } from "@/app/router";
import { AppIntro } from "@/app/AppIntro";
import "@/design/global.css";
import { initMonitoring } from "@/lib/monitoring";
import { registerServiceWorker } from "@/lib/pwa";
import { captureInstallPrompt } from "@/features/pwa/install";

const root = document.getElementById("root");
if (!root) throw new Error("#root element missing from index.html");

initMonitoring();
registerServiceWorker();
captureInstallPrompt();

// Any vendor action refused with 402 SUBSCRIPTION_REQUIRED goes to Billing (once per burst of requests).
let lastBillingRedirect = 0;
onSubscriptionRequired(() => {
  if (Date.now() - lastBillingRedirect < 3000 || window.location.pathname.startsWith("/billing")) return;
  lastBillingRedirect = Date.now();
  void import("@/stores/toast").then(({ toast }) =>
    toast.warning("Your store needs an active plan", "Renew in Billing to keep selling."),
  );
  void router.navigate("/billing");
});

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
      <AppIntro />
    </AppProviders>
  </StrictMode>,
);
